module.exports = __webpack_public_path__ + "static/img/5设计师1.a0f3e54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/5设计师1.png
// module id = P/vg
// module chunks = 1